import 'slick-carousel/slick/slick';

function cookies() {
    // $("body").niceScroll();
    var cookieInfo = $('.cookie'),
        cookieClose = $('.cookie').find('.cookie-accept');
    checkCookie();

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + expires + "; path=/";

    }

    function getCookie(cname) {

        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return '';
    }

    function checkCookie() {
        var isExist = getCookie('pa-media');
        if (isExist != '') {
            cookieInfo.hide();
        } else {
            cookieInfo.show();
            cookieClose.on('click', function (e) {
                e.preventDefault();
                cookieInfo.hide();
                isExist = true;
                if (isExist != "" && isExist != null) {
                    setCookie('pa-media', isExist, 365);
                }
            });
        }
    }
}

function filterTabs() {
    const filters = $('[data-filter]');
    const listings = $('[data-listing]');
    if (filters.length > 0) {
        filters.each((i, el) => {
            const filter = $(el);
            const listing = $('[data-listing="' + filter.data('filter') + '"]');

            filter.on('click', () => {
                if (!filter.hasClass('current')) {
                    filters.removeClass('current');
                    listings.removeClass('active');
                    filter.addClass('current');
                    listing.addClass('active');
                }
            });
        });
    }
}

function verticalFilter() {
    const filters = $('[data-tab]');
    const listings = $('[data-content]');
    if (filters.length > 0) {
        filters.each((i, el) => {
            const filter = $(el);
            const listing = $('[data-content="' + filter.data('tab') + '"]');
            filter.on('click', () => {
                if (!filter.hasClass('current')) {
                    filters.removeClass('current');
                    listings.removeClass('active');
                    filter.addClass('current');
                    listing.addClass('active');
                }
            });
        });
    }
}

function accordion() {
    let accordion = document.querySelectorAll(".accordion__outside");
    if (accordion.length > 0) {
        accordion.forEach(el => {
            el.addEventListener("click", function (e) {
                var clicked = e.currentTarget;
                let arrow = clicked.querySelector('.accordion__arrow');
                var panel = this.nextElementSibling;
                let insideELement = panel.querySelector('.inside__element');
                if (panel.style.height) {
                    panel.style.height = null;
                    arrow.classList.remove('rotated');
                    this.classList.toggle("active");
                } else {
                    let everyPanel = document.querySelectorAll('.active');
                    everyPanel.forEach((e) => {
                        e.classList.remove('active');
                    });
                    let everyInsideEl = document.querySelectorAll('.accordion__inside');
                    everyInsideEl.forEach((e) => {
                        e.style.height = null;
                    });
                    let everyRotaded = document.querySelectorAll('.rotated');
                    everyRotaded.forEach((el) => {
                        el.classList.remove('rotated');
                    });
                    this.classList.toggle("active");
                    arrow.classList.add('rotated');
                    panel.style.height = insideELement.scrollHeight + 50 + "px";
                }
            });
        });
        accordion[0].click();
    }
}

function searchBar() {
    const search = document.querySelector('.icon-desktop');
    const searchBar = document.querySelector('.search-bar-desktop');
    const searchBarMobile = document.querySelector('.search-bar');
    const searchMobile = document.querySelector('.icon-search');
    const mobileClose = document.querySelector('body section');
    if (search) {
        search.addEventListener('click', (e) => {
            if (searchBar.style.width) {
                searchBar.style.width = null;
                searchBar.style.paddingLeft = null;
                searchBar.style.border = null;
                if (!search.classList.contains('no-white')) {
                    search.classList.add('white');
                }
            } else {
                searchBar.style.width = 230 + 'px';
                searchBar.style.paddingLeft = 15 + 'px';
                searchBar.style.border = "2px solid black";
                search.classList.remove('white');
            }
        });
    }
    if (searchMobile) {
        searchMobile.addEventListener('click', (e) => {
            if (searchBarMobile.style.width) {
                searchBarMobile.style.width = null;
                searchBarMobile.style.paddingLeft = null;
            } else {
                searchBarMobile.style.width = 120 + 'px';
                searchBarMobile.style.paddingLeft = 15 + 'px';
            }
        });
        mobileClose.addEventListener('click', (el) => {
            searchBarMobile.style.width = null;
            searchBarMobile.style.paddingLeft = null;
        });
    }
}

function slider() {
    let homepage = document.querySelector('.homepage');
    if (homepage) {
        $('.slider-home').slick({
            swipe: true,
            touchMove: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
            cssEase: 'ease-in-out',
            touchThreshold: 100
        });
    }
    let testimonials = document.querySelector('.section__testimonials');
    if (testimonials) {
        $('.testimonial__slider--testimonial .testimonial__slider').slick({
            dots: true,
            infinite: true,
            arrows: true,
            speed: 300,
            centerMode: true,
            centerPadding: '20px',
            slidesToShow: 3,
            slidesToScroll: 1,
            appendDots: $('.testimonial__slider--testimonial .dots'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        adaptiveHeight: true,
                        centerMode: false,
                    }
                },
            ]
        });
    }
    let prSlider = document.querySelector('.pr-slider');
    if (prSlider) {
        $('.pr-slider').slick({
            arrows: true,
            prevArrow: `<div class="prev-arrow">
				<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve">
				<g>
					<g>
						<path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12
							c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028
							c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265
							c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/>
					</g>
				</g>
				</svg>
			 </div>`,
            nextArrow:
                `<div class="next-arrow">
				<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve">
				<g>
					<g>
						<path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12
							c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028
							c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265
							c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/>
					</g>
				</g>
				</svg>
			  </div>`,
            adaptiveHeight: true,
        });
    }
    let carouselHeader = document.querySelector('.carousel-header');
    if (carouselHeader) {
        $(carouselHeader).slick();
    }


    let corporateClients = document.querySelector('.corporate-clients');
    if (corporateClients) {
        $('.corporate-clients__carousel').slick({
            swipe: true,
            touchMove: true,
            arrows: true,
            autoplay: false,
            dots: false,
            slidesToShow: 4,
            center: true,
            loop: true,
            prevArrow: $('.corporate-clients .prev'),
            nextArrow: $('.corporate-clients .next'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    }
}

function faqItem() {
    const toggleList = document.querySelectorAll('[data-accordion-toggle]');

    toggleList.forEach((element) => {

        const sectionElement = element.parentNode,
            contentElement = sectionElement.querySelector('[data-accordion-content]');

        element.addEventListener('click', (event) => {
            let contentHeight;

            sectionElement.classList.toggle('active');
            sectionElement.classList.contains('active') ? contentHeight = contentElement.scrollHeight : contentHeight = 0;
            contentElement.setAttribute('style', 'max-height: ' + contentHeight + 'px');
        });
    });
}

function simpleSlider() {
    let simpleSlider = document.querySelector('.simple-slider');
    if (simpleSlider) {
        $('.simple-slider').slick({
            arrows: true,
            prevArrow: `<div class="simple-slider__prev-arrow">
				<svg width="21" height="34" viewBox="0 0 21 34" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M17.4699 0L0.5 16.9702L17.4699 33.9404L20.2999 31.1124L6.15598 16.9702L20.2999 2.82804L17.4699 0Z" fill="white"/>
				</svg>
			 </div>`,
            nextArrow:
                `<div class="simple-slider__next-arrow">
				<svg width="21" height="34" viewBox="0 0 21 34" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M3.53005 33.9404L20.5 16.9702L3.53005 0L0.70006 2.82804L14.844 16.9702L0.70006 31.1124L3.53005 33.9404Z" fill="white"/>
				</svg>
			  </div>`,

        });
    }
}

function mediapointSlider() {
    let simpleSlider = document.querySelector('.mp-image-text-slider__slider');
    if (simpleSlider) {
        $('.mp-image-text-slider__slider').slick({
            arrows: true,
            dots: true,
            prevArrow: `<div class="mp-image-text-slider-prev-arrow"><svg width="30" height="51" viewBox="0 0 30 51" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M27.2731 48.749L4.18794 25.6639L27.2731 2.57879" stroke="#D5D5D5" stroke-width="5"/>
			</svg></div>
			`,
            nextArrow:
                `<div class="mp-image-text-slider-next-arrow"><svg width="29" height="51" viewBox="0 0 29 51" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1.95752 2.57874L25.0427 25.6638L1.95752 48.749" stroke="#D5D5D5" stroke-width="5"/>
				</svg></div>
				`,

        });
    }
}

function setupHexagonLinks() {
    const hexagonLinks = document.querySelectorAll('[data-hexagon-link]');

    hexagonLinks.forEach((element) => {
        element.addEventListener('click', (event) => {
            window.location.href = element.dataset.hexagonLink;
        });
    });
}

function setupMediapointBlogLoadMoreButton() {
    let page = 2;
    let loading = false;

    const button = $('[data-mediapoint-blog-load-more-button]');

    button.click(function () {
        if (loading) {
            return;
        }
        loading = true;

        $.ajax({
            url: settings.ajax_url, // URL dla zapytania AJAX
            type: 'POST',
            data: {
                action: 'mediapoint_blog_load_more_posts',
                pageNr: page
            },
            success: function (response) {
                if (response) {
                    $('[data-mediapoint-blog-posts]').append(response);
                    page++;
                    loading = false;
                } else {
                    button.hide(); // hide button if no more posts
                }
            },
            error: function (error) {
                console.log('Error loading posts.', error.message);
                loading = false;
            }
        });
    });
}

export default {
    cookies,
    filterTabs,
    verticalFilter,
    accordion,
    searchBar,
    slider,
    faqItem,
    simpleSlider,
    mediapointSlider,
    setupHexagonLinks,
    setupMediapointBlogLoadMoreButton
};